/* ============================================================
   JBOXLY — FUENTE UNICA DE PRECIOS
   v9 (19-oct-2026): envio_usa = envio del vendedor en Estados Unidos (por unidad,
   lo trae cada producto). Linea aparte, se paga hoy y entra en la base del 15 %.
   ------------------------------------------------------------
   Toda formula de precio del sitio vive AQUI y en ningun otro
   lado. La usan el carrito (compra-en-jboxly), el panel de
   cliente (dashboard-jboxly) y el panel admin (admin-jboxly).

   Si hay que cambiar una tarifa, se cambia en este archivo y
   los tres lugares quedan iguales el mismo segundo. Antes cada
   pantalla tenia su propia copia y se desincronizaron: en
   Argentina el cliente veia un precio y el panel cobraba otro.

   Modelo de cobro:
     - El cliente paga HOY el valor de los productos (y el tax de
       compra en USA cuando la tienda lo cobra).
     - Manejo, seguro, impuestos y envio se cobran cuando la
       mercancia llega al almacen de Dallas y se conoce el peso
       real. Se muestran desde el principio como estimado.

   v6 (16-oct-2026) — ARGENTINA: el envio sale de una TABLA REAL de cajas x libras
     (cotizaciones de JSTORE / Managed Markets), no de una formula por libra.
     - C.AR_TARIFAS: { cajas: [ { nombre, l, a, h, activa, plano_precio, plano_hasta,
       luego: [...], promo_precio, promo_hasta } ], colchon_pct, pack_pct, impuesto_envio_pct }.
       Etiqueta de una caja a N lb = plano_precio si N <= plano_hasta; si no luego[N-plano_hasta-1].
     - cajaAR(lbs, vol): elige la opcion MAS BARATA donde cabe el pedido (volumen util =
       caja x pack_pct, peso <= tope de la tabla): promo cerrada (Chica $70 hasta 10 lb,
       Grande $195 hasta 23 lb) o etiqueta x (1 + colchon). Tambien prueba "2 cajas promo"
       (2 Chicas antes que 1 Grande). Si nada cabe, devuelve null y calcular() usa la
       formula por libra de siempre como respaldo (marcada en envio_nota).
     - Sin medidas (vol = 150 por defecto) el volumen se estima por peso: 80 in3 por libra.
     - La tabla viene de api/tarifas-ar (editable en el admin); se guarda 6 h en localStorage
       y hay una copia por defecto aqui para que nunca falte. cargarTarifasAR(cb) la refresca.
     - El checkout de JSTORE suma impuesto_envio_pct (26.4 %) sobre el envio, como antes.

   v5 (16-oct-2026) — ARGENTINA: las comisiones de la plataforma ya NO
     se le cobran al cliente (decision de Jesus). El 3.5% de Managed
     Markets y el 3.3% + $0.30 de Shopify Payments son el costo de cobrar
     y los absorbe JBOXLY. `comisiones` queda en 0 en el desglose (asi la
     linea desaparece sola en carrito, Mi cuenta y admin) y el manejo del
     15% se calcula sobre producto + tax + envio + impuestos, sin ellas.
     costosAR() sigue calculando lo que JBOXLY paga en `comisiones_jboxly`
     (solo informativo; no entra en ningun total). Los pedidos guardados
     conservan su desglose: nada se mueve hasta que se recalcule a mano.

   v4 (10-oct-2026) — ARGENTINA: dos modos de Managed Markets
     Probado con el mismo carrito en JSTORE (10-oct):
     - Modo "incluido" (toggle "incluir aranceles e impuestos en los
       precios" ENCENDIDO): Global-e cobra un ESTIMADO garantizado:
       ~37% sobre productos y 26.4% sobre el flete + 3.5% Global-e.
     - Modo "real" (toggle APAGADO): calcula el impuesto argentino real:
       franquicia de USD 400 por envio (arancel 0 hasta ahi; si se pasa,
       41% sobre TODO el valor) + IVA/tasas 24% sobre productos + flete
       + 21% sobre el arancel. Global-e 3.5% sale del payout.
     - Regla: al cliente SIEMPRE se le cobra el modo mas caro (decision
       de Jesus). En JSTORE se usa el barato (<= $400 "real", > $400
       "incluido") y la diferencia es margen. El admin muestra los dos.
     - Peso facturable AR = el mayor entre peso real y volumetrico
       (largo x ancho x alto / 139, como FedEx), cuando se conocen medidas.
     - Envio AR: estimado FedEx ICP por libra (5 lb $38.80 · 16 lb ~$150 ·
       22 lb $196 en etiquetas reales) + 10% de colchon, hasta que haya
       tarifas fijas por caja.

   v3 (10-oct-2026) — ARGENTINA con el costo real del canal
     - La aduana argentina cobra sobre producto + flete (valor CIF):
       ~42% sobre productos y ~26.4% sobre el envio (lo que Global-e
       nos cobro en JBX1003/JBX1004). Antes solo se cobraba 35% sobre
       productos y el flete iba al costo: cada pedido salia a perdida.
     - Comisiones de plataforma (las paga JBOXLY al enviar por JSTORE /
       Managed Markets): 3.5% de Global-e (sobre el precio final del
       producto) + 3.3% + $0.30 de Shopify Payments. Nueva linea
       `comisiones` del desglose; entra en el total y en "al llegar".
     - El manejo 15% se calcula sobre TODO (producto + tax + envio +
       impuestos + comisiones): es la ganancia, va encima del costo.
     - Pedidos viejos (desglose sin `comisiones`): se completa en 0 y
       nada se mueve.

   v2 (1-oct-2026)
     - Tax de compra en USA (8.25%, Texas): lo cobran las tiendas
       al comprar. Amazon y eBay NO (estan exentos). Va en "paga
       ahora" porque JBOXLY lo paga el dia que compra.
     - Pedidos v2 (los que ya traen tax_usa_pct en su desglose):
       el manejo del 15% se calcula igual que en el carrito, sobre
       producto + tax de compra en USA + envio + impuestos (decision
       de Jesus, 1-oct-2026). Los pedidos viejos (v1) y los
       manuales se recalculan EXACTAMENTE como antes, asi su total
       y su "falta por cobrar" no se mueven.
     - El carrito (assets/compra-en-jboxly.js) no carga este
       archivo y tiene su copia de la regla del tax: jbxPagaTaxUSA.
       Si cambias una, cambia la otra.
   ============================================================ */
(function (w) {
  'use strict';

  var C = {
    FEE_PCT: 0.15,        /* Manejo, logistica, consolidacion y reempaque */
    FEE_FIJO: 0,
    SEGURO_VE: 5,         /* Seguro obligatorio Venezuela: fijo por pedido */
    /* ---- Argentina (v4) ---- */
    IMP_AR_PCT: 0.37,        /* modo "incluido": estimado Global-e sobre PRODUCTOS (32-42% segun categoria) */
    IMP_AR_ENVIO_PCT: 0.264, /* modo "incluido": sobre el FLETE */
    AR_FRANQUICIA: 400,      /* modo "real": sin arancel hasta USD 400 de productos por envio */
    AR_ARANCEL_PCT: 0.41,    /* modo "real": arancel sobre TODO el valor si pasa la franquicia (177.06/431.86) */
    AR_IVA_PCT: 0.24,        /* modo "real": IVA + tasas sobre productos + flete */
    AR_IVA_ARANCEL_PCT: 0.21,/* modo "real": IVA sobre el arancel */
    AR_FEE_GLOBALE: 0.035,   /* Managed Markets 3.5% — lo paga JBOXLY (v5), solo informativo */
    AR_FEE_PAGO: 0.033,      /* Shopify Payments en JSTORE: 3.3% + $0.30 — lo paga JBOXLY (v5), solo informativo */
    AR_FEE_PAGO_FIJO: 0.30,
    AR_TARIFAS_URL: 'https://jboxly-realtime-search.vercel.app/api/tarifas-ar',
    AR_TARIFAS: null,        /* tabla en uso (se llena abajo con la default y luego con la del admin) */
    AR_VIVA: null,           /* v8: curva viva FedEx por libra (api/tarifa-viva via api/tarifas-ar): { curva:{lb:precio con 26.4 %}, incluye_impuesto } */
    AR_VOL_POR_LB: 80,       /* in3 por libra cuando el producto no trae medidas */
    AR_VOL_MIN: 60,
    AR_ENVIO_BASE: 43,       /* respaldo por libra (solo si el pedido no cabe en la tabla) */
    AR_ENVIO_LB: 8.9,        /* + por libra adicional */
    AR_ENVIO_COLCHON: 1.10,  /* 10% para comision y diferencias de etiqueta */
    AR_DIM_FACTOR: 200,      /* peso volumetrico: largo x ancho x alto (in) / 200. FedEx publica 139, pero
                                JSTORE cobra con ~200 (16x16x16.5 a 22 lb = peso real; 24x18x18 a 30 lb = 39 lb).
                                Editable en la tabla como dim_divisor. */
    TARIFA_LB_VE: 8.5,    /* USD por libra, aereo Venezuela */
    TARIFA_KG_AR: 25,     /* USD por kilo CON el 26.4 % incluido, Argentina: ESTIMADO cuando faltan medidas o no entra en caja (v7) */
    MINIMO_KG_AR: 1,
    TAX_USA_PCT: 0.0825,  /* Sales tax de Texas que cobran las tiendas */
    TIENDAS_SIN_TAX: ['amazon', 'ebay'],  /* exentas: no nos cobran tax */
    CAJAS: [
      { nombre: 'Small',  vol: 11 * 11 * 17, precio: 70 },
      { nombre: 'Medium', vol: 15 * 16 * 20, precio: 160 },
      { nombre: 'Large',  vol: 15 * 16 * 26, precio: 240 },
      { nombre: 'XLarge', vol: 20 * 20 * 24, precio: 330 }
    ]
  };

  function r2(n) { return Math.round((Number(n) || 0) * 100) / 100; }
  function dinero(n) { return '$' + r2(n).toFixed(2); }

  /* ARGENTINA (v4): impuestos de importacion + comisiones de la plataforma.
     productos = valor de los productos (USD), envio = flete (USD),
     modo = 'incluido' | 'real' | 'auto' (auto elige el mas barato).
     - 'incluido' (JSTORE con el toggle "incluir aranceles e impuestos en los
       precios" ENCENDIDO): Global-e estima 37% del producto + 26.4% del flete
       y lo garantiza. Fee Managed Markets = (producto + imp) / 0.965 - (producto + imp).
     - 'real' (toggle APAGADO): impuesto argentino de verdad. Sin arancel hasta
       USD 400 de productos por envio (franquicia courier); si pasa, 41% sobre
       todo + 21% de IVA sobre ese arancel. IVA y tasas 24% sobre producto y flete.
       Fee Managed Markets = 3.5% de (producto + envio).
     - fee_pago: 3.3% + $0.30 sobre producto + envio (Shopify Payments de JSTORE).
     - v5: fee_globale y fee_pago son lo que paga JBOXLY; al cliente NO se le
       cobran. `comisiones` (lo que paga el cliente) = 0; la suma de las dos
       va en `comisiones_jboxly`, solo para informacion del admin.
     Con 'auto' se cobra el modo MAS CARO. Devuelve .alternativa = { modo, costo,
     margen }: el otro modo (el barato, para usarlo en JSTORE) y cuanto sobra. */
  function costosAR(productos, envio, modo) {
    productos = Number(productos) || 0; envio = Number(envio) || 0;
    if (!(productos > 0)) return { modo: 'real', impuestos: 0, impuestos_productos: 0, impuestos_envio: 0, aranceles: 0, comisiones: 0, comisiones_jboxly: 0, fee_globale: 0, fee_pago: 0, alternativa: null };
    /* 17-oct-2026: Shopify Payments cobra 3.3 % + $0.30 sobre TODO lo que paga el cliente
       (productos + envio + impuestos), no solo sobre producto + envio. Visto en el payout
       del pedido del 16-oct: $55.18 cobrados → fee $2.12 (= 55.18 × 3.3 % + 0.30). */
    var spDe = function (imp) { return r2((productos + envio + imp) * C.AR_FEE_PAGO + C.AR_FEE_PAGO_FIJO); };
    /* modo "incluido": estimado de Global-e, garantizado */
    var iP = r2(productos * C.IMP_AR_PCT), iE = r2(envio * C.IMP_AR_ENVIO_PCT);
    var conImp = productos + iP;
    var mmI = r2(conImp / (1 - C.AR_FEE_GLOBALE) - conImp);
    var sp = spDe(iP + iE);
    var inc = { modo: 'incluido', impuestos: r2(iP + iE), impuestos_productos: iP, impuestos_envio: iE, aranceles: 0,
      comisiones: 0, comisiones_jboxly: r2(mmI + sp), fee_globale: mmI, fee_pago: sp };
    /* modo "real": impuesto argentino con franquicia de 400 */
    var ar = productos > C.AR_FRANQUICIA ? r2(productos * C.AR_ARANCEL_PCT) : 0;
    var rP = r2(ar + productos * C.AR_IVA_PCT + ar * C.AR_IVA_ARANCEL_PCT), rE = r2(envio * C.AR_IVA_PCT);
    var mmR = r2((productos + envio) * C.AR_FEE_GLOBALE);
    var spR = spDe(rP + rE);
    var real = { modo: 'real', impuestos: r2(rP + rE), impuestos_productos: rP, impuestos_envio: rE, aranceles: ar,
      comisiones: 0, comisiones_jboxly: r2(mmR + spR), fee_globale: mmR, fee_pago: spR };
    /* v5: el costo que decide el modo es lo que paga el cliente: solo impuestos */
    var costo = function (x) { return x.impuestos + x.comisiones; };
    var elegido, otro;
    if (modo === 'incluido') { elegido = inc; otro = real; }
    else if (modo === 'real') { elegido = real; otro = inc; }
    /* 'auto': se COBRA con el modo mas caro (decision de Jesus, 10-oct). En JSTORE
       se usa el mas barato y la diferencia queda como margen para cubrir perdidas. */
    else { if (costo(real) >= costo(inc)) { elegido = real; otro = inc; } else { elegido = inc; otro = real; } }
    /* alternativa = el otro modo; margen = lo que sobra si en JSTORE se usa ese (si es positivo) */
    elegido.alternativa = { modo: otro.modo, costo: r2(costo(otro)), margen: r2(costo(elegido) - costo(otro)) };
    return elegido;
  }
  /* ── v6: TABLA DE TARIFAS ARGENTINA (cajas x libras) ── */
  /* Copia por defecto = cotizaciones del 16-oct-2026. La que manda es la del admin (api/tarifas-ar). */
  var AR_TARIFAS_DEFAULT = {
    v: 1, impuesto_envio_pct: 0.264, colchon_pct: 0.10, pack_pct: 0.85, dim_divisor: 200,
    cajas: [
      { id: 'mini', nombre: 'Mini', l: 6, a: 4, h: 4, activa: true, plano_precio: 0, plano_hasta: 0, luego: [24.19, 26.65, 30.78, 34.82, 38.84], promo_precio: 0, promo_hasta: 0 },
      { id: 'chica', nombre: 'Chica', l: 16, a: 12, h: 10, activa: true, plano_precio: 58.75, plano_hasta: 10, luego: [110.64, 111.83, 119.79, 139.46, 141.43, 145.87, 153.00], promo_precio: 70, promo_hasta: 10 },
      { id: 'mediana', nombre: 'Mediana', l: 18, a: 14, h: 12, activa: false, plano_precio: 146.97, plano_hasta: 16, luego: [154.94, 166.90, 172.98, 173.55, 180.15, 185.66, 186.22, 190.76, 192.80, 208.25, 209.81, 211.08, 219.59, 222.95], promo_precio: 0, promo_hasta: 0 },
      { id: 'grande', nombre: 'Grande', l: 20, a: 16, h: 14, activa: true, plano_precio: 186.22, plano_hasta: 23, luego: [190.76, 192.80, 208.25, 209.81, 211.08, 219.59, 222.95], promo_precio: 195, promo_hasta: 23 },
      { id: 'xl', nombre: 'XL', l: 22, a: 18, h: 14, activa: true, plano_precio: 192.80, plano_hasta: 25, luego: [208.25, 209.81, 211.08, 219.59, 222.95], promo_precio: 0, promo_hasta: 0, cotizar: true },
      { id: 'xxl', nombre: 'XXL', l: 24, a: 18, h: 18, activa: true, plano_precio: 282.87, plano_hasta: 30, luego: [], promo_precio: 0, promo_hasta: 0, cotizar: true },
      { id: 'jumbo', nombre: 'Jumbo', l: 24, a: 20, h: 20, activa: true, plano_precio: 292.69, plano_hasta: 30, luego: [], promo_precio: 0, promo_hasta: 0, cotizar: true }
    ]
  };
  C.AR_TARIFAS = AR_TARIFAS_DEFAULT;

  /* Etiqueta (sin impuestos) de una caja a N libras; 0 = esa caja no llega a ese peso */
  function tarifaCajaAR(c, lb) {
    lb = Math.max(1, Math.ceil(Number(lb) || 0));
    if ((c.plano_hasta || 0) > 0 && lb <= c.plano_hasta) return Number(c.plano_precio) || 0;
    var p = (c.luego || [])[lb - (c.plano_hasta || 0) - 1];
    return p > 0 ? Number(p) : 0;
  }
  function topeCajaAR(c) { return (c.plano_hasta || 0) + (c.luego || []).length; }

  /* Volumen del pedido para elegir caja: con medidas se usa; sin medidas, por peso */
  /* Medidas de un producto como [mayor, medio, menor] (in) o null si no las trae.
     El carrito guarda `medidas: {l, a, h}`; los items en vivo traen `dims: {largo, ancho, alto}`. */
  function ladosDe(p) {
    var m = p && (p.medidas || p.dims);
    if (!m) return null;
    var l = [Number(m.l != null ? m.l : m.largo) || 0, Number(m.a != null ? m.a : m.ancho) || 0, Number(m.h != null ? m.h : m.alto) || 0];
    if (!(l[0] > 0 && l[1] > 0 && l[2] > 0)) return null;
    return l.sort(function (x, y) { return y - x; });
  }
  function volAR(productos) {
    var v = 0;
    (productos || []).forEach(function (p) {
      var cant = parseInt(p.cantidad, 10) || 1;
      var l = ladosDe(p);
      var vp = l ? l[0] * l[1] * l[2] : Number(p.vol);
      if (!(vp > 0) || vp === 150) vp = Math.max(C.AR_VOL_MIN, (Number(p.peso) || 1) * C.AR_VOL_POR_LB);
      v += vp * cant;
    });
    return v;
  }
  /* Lados de los productos que SI traen medidas (para la regla "cabe de verdad") */
  function ladosAR(productos) {
    var out = [];
    (productos || []).forEach(function (p) { var l = ladosDe(p); if (l) out.push(l); });
    return out;
  }
  /* Cuantos bultos van en el pedido (suma de cantidades) */
  function piezasAR(productos) {
    var n = 0;
    (productos || []).forEach(function (p) { n += parseInt(p.cantidad, 10) || 1; });
    return n;
  }
  /* ¿Algun producto viene sin medidas? → la caja es estimada */
  function sinMedidasAR(productos) {
    return (productos || []).some(function (p) { return !ladosDe(p); });
  }
  /* Cada producto, por sus tres lados ordenados, tiene que caber en la caja */
  function cabeEnCajaAR(c, lados) {
    if (!lados || !lados.length) return true;
    var cj = [Number(c.l) || 0, Number(c.a) || 0, Number(c.h) || 0].sort(function (x, y) { return y - x; });
    for (var i = 0; i < lados.length; i++) {
      if (lados[i][0] > cj[0] || lados[i][1] > cj[1] || lados[i][2] > cj[2]) return false;
    }
    return true;
  }

  /* La opcion MAS BARATA donde cabe el pedido. null = no cabe en ninguna caja de la tabla.
     Devuelve { caja, id, n, precio, promo, etiqueta, hasta_lb, medidas } */
  /* 17-oct-2026 (v7): piezas = cuantos bultos van (suma de cantidades). Un solo bulto CON
     medidas que cabe por lados cabe aunque llene la caja: el 85 % de volumen util es
     para cuando se combinan varias cosas. Antes un paquete de 6x4x4 no entraba en la
     Mini de 6x4x4 y saltaba a la Chica ($70 en vez de $33). */
  function cajaAR(lbs, vol, tabla, lados, piezas) {
    var t = tabla || C.AR_TARIFAS || AR_TARIFAS_DEFAULT;
    var lb = Math.max(1, Math.ceil(Number(lbs) || 0));
    vol = Number(vol) || 0;
    var colchon = Number(t.colchon_pct); if (!(colchon >= 0)) colchon = 0.10;
    var pack = Number(t.pack_pct); if (!(pack > 0 && pack <= 1)) pack = 0.85;
    if (piezas === 1 && lados && lados.length === 1) pack = 1;
    var mejor = null;
    (t.cajas || []).forEach(function (c) {
      if (c.activa === false) return;
      var volCaja = (Number(c.l) || 0) * (Number(c.a) || 0) * (Number(c.h) || 0) * pack;
      if (!(volCaja > 0)) return;
      if (!cabeEnCajaAR(c, lados)) return; /* algun producto es mas largo/ancho que la caja */
      var medidas = c.l + '\u00d7' + c.a + '\u00d7' + c.h + ' in';
      /* una caja */
      if (vol <= volCaja && lb <= topeCajaAR(c)) {
        var op;
        if (c.promo_precio > 0 && lb <= (c.promo_hasta || 0)) {
          op = { caja: c.nombre, id: c.id, n: 1, precio: r2(c.promo_precio), promo: true, etiqueta: tarifaCajaAR(c, lb), hasta_lb: c.promo_hasta, medidas: medidas, cotizar: c.cotizar === true };
        } else {
          var e = tarifaCajaAR(c, lb);
          if (e > 0) op = { caja: c.nombre, id: c.id, n: 1, precio: r2(e * (1 + colchon)), promo: false, etiqueta: e, hasta_lb: topeCajaAR(c), medidas: medidas, cotizar: c.cotizar === true };
        }
        if (op && (!mejor || op.precio < mejor.precio)) mejor = op;
      }
      /* dos cajas promo (2 Chicas antes que 1 Grande) */
      if (c.promo_precio > 0 && c.promo_hasta > 0 && vol <= 2 * volCaja && lb <= 2 * c.promo_hasta) {
        var p2 = r2(2 * c.promo_precio);
        if (!mejor || p2 < mejor.precio) mejor = { caja: c.nombre + ' \u00d72', id: c.id, n: 2, precio: p2, promo: true, etiqueta: r2(2 * tarifaCajaAR(c, Math.ceil(lb / 2))), hasta_lb: 2 * c.promo_hasta, medidas: medidas + ' (x2)' };
      }
    });
    return mejor;
  }

  /* Respaldo por libra (formula vieja), solo cuando el pedido no cabe en la tabla */
  function envioARFormula(lbs) {
    lbs = Math.max(Number(lbs) || 0, 1);
    var base = lbs <= 5 ? C.AR_ENVIO_BASE : C.AR_ENVIO_BASE + (lbs - 5) * C.AR_ENVIO_LB;
    return r2(base * C.AR_ENVIO_COLCHON);
  }
  /* Envio Argentina: tabla si cabe, formula si no. vol opcional (sin vol: solo por peso) */
  function envioAR(lbs, vol, lados) {
    var sel = cajaAR(lbs, vol || 0, null, lados);
    return sel ? sel.precio : envioARFormula(lbs);
  }

  /* Trae la tabla del admin (api/tarifas-ar). Guarda 6 h en localStorage; cb(tabla) al llegar. */
  function usarTarifasAR(t) { if (t && t.cajas && t.cajas.length) C.AR_TARIFAS = t; return C.AR_TARIFAS; }
  function usarVivaAR(v) { C.AR_VIVA = (v && v.curva && Object.keys(v.curva).length) ? v : null; return C.AR_VIVA; }
  /* v8 (17-oct-2026): "PROPIA CAJA". Un solo bulto con medidas viaja tal cual y FedEx lo
     cobra por PESO FACTURABLE = el mayor entre el peso real y el volumetrico
     (L x A x H / divisor; 200 segun las cotizaciones reales de JSTORE, editable en la tabla como dim_divisor).
     Ese precio sale exacto de la curva viva por libra que api/tarifa-viva captura en JSTORE
     (la curva dice si trae o no el 26.4 %). Se le aplica el mismo colchon que a las cajas sin promo.
     Devuelve { precio (etiqueta + colchon, sin impuesto), lb (facturable), real, volumetrico,
     por_volumen, viva (precio de la curva), medidas } o null si no hay curva para esa libra. */
  function dimDivisorAR() { var t = C.AR_TARIFAS || AR_TARIFAS_DEFAULT; var d = Number(t.dim_divisor); return d > 0 ? d : C.AR_DIM_FACTOR; }
  function propiaCajaAR(productos, lbs) {
    var V = C.AR_VIVA; if (!V || !V.curva) return null;
    if (piezasAR(productos) !== 1) return null;
    var lados = ladosAR(productos); if (lados.length !== 1) return null;
    var l = lados[0];
    var real = Math.max(1, Math.ceil(Number(lbs) || 0));
    var dim = Math.ceil(l[0] * l[1] * l[2] / dimDivisorAR());
    var lb = Math.max(real, dim);
    var p = Number(V.curva[lb]); if (!(p > 0)) return null; /* fuera de la curva */
    var t = C.AR_TARIFAS || AR_TARIFAS_DEFAULT;
    var colchon = Number(t.colchon_pct); if (!(colchon >= 0)) colchon = 0.10;
    var base = V.incluye_impuesto === false ? p : p / (1 + (Number(t.impuesto_envio_pct) || C.IMP_AR_ENVIO_PCT));
    return { precio: r2(base * (1 + colchon)), lb: lb, real: real, volumetrico: dim, por_volumen: dim > real, viva: p, medidas: l[0] + '\u00d7' + l[1] + '\u00d7' + l[2] + ' in' };
  }
  function cargarTarifasAR(cb) {
    try {
      var c = JSON.parse(w.localStorage.getItem('jbx_tarifas_ar') || 'null');
      if (c && c.t && c.ts && (Date.now() - c.ts) < 6 * 3600000) { usarTarifasAR(c.t); usarVivaAR(c.v || null); }
    } catch (e) {}
    if (typeof w.fetch !== 'function') return Promise.resolve(C.AR_TARIFAS);
    return w.fetch(C.AR_TARIFAS_URL).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.ok && d.tarifas && d.tarifas.cajas) {
        usarTarifasAR(d.tarifas);
        usarVivaAR(d.viva || null);
        try { w.localStorage.setItem('jbx_tarifas_ar', JSON.stringify({ t: d.tarifas, v: d.viva || null, ts: Date.now() })); } catch (e) {}
        if (typeof cb === 'function') cb(d.tarifas);
      }
      return C.AR_TARIFAS;
    }).catch(function () { return C.AR_TARIFAS; });
  }

  /* Saca el precio numerico de un producto aunque solo tenga el
     texto ("$12.02"). Los pedidos viejos no traen precioNum. */
  function precioDe(p) {
    if (typeof p.precioNum === 'number' && p.precioNum > 0) return p.precioNum;
    return parseFloat(String(p.precio || '').replace(/[^0-9.]/g, '')) || 0;
  }

  /* ¿La tienda nos cobra sales tax al comprar este producto?
     - Amazon y eBay: no.
     - Comparador (google): no, si en realidad es de Amazon o eBay.
     - Paquetes de casillero y productos sin tienda: no (no los
       compramos nosotros o no sabemos de donde vienen). */
  function pagaTaxUSA(p) {
    if (!p) return false;
    var t = String(p.tienda || '').toLowerCase().trim();
    if (!t || t === 'casillero' || t === 'jboxly') return false;
    if (C.TIENDAS_SIN_TAX.indexOf(t) !== -1) return false;
    if (t === 'google' && /amazon|ebay/i.test(String(p.titulo || '') + ' ' + String(p.tituloEs || '') + ' ' + String(p.url || ''))) return false;
    return true;
  }

  /* Tax de compra de una lista de productos (USD, redondeado) */
  function taxUSA(productos) {
    var base = 0;
    (productos || []).forEach(function (p) {
      if (!pagaTaxUSA(p)) return;
      base += precioDe(p) * (parseInt(p.cantidad, 10) || 1);
    });
    return r2(base * C.TAX_USA_PCT);
  }

  /* Pedido v2 = nacio (o se rehizo) con el modelo del tax de compra.
     Solo esos se recalculan con las reglas nuevas. */
  function esV2(pedido) {
    if (!pedido) return false;
    if (pedido.tax_usa_aplica === true) return true;
    var d = pedido.desglose;
    return !!(d && (Number(d.v) >= 2 || (typeof d.tax_usa_pct === 'number' && d.tax_usa_pct > 0)));
  }

  /* pedido: { pais, envio_tipo, desglose? }  ·  productos: array de la orden
     Devuelve el desglose completo. Nunca lanza: ante datos raros
     devuelve ceros, que es preferible a romper la pantalla. */
  function calcular(pedido, productos) {
    pedido = pedido || {};
    productos = productos || [];
    var v2 = esV2(pedido);

    var valor = 0, peso = 0, vol = 0, gravable = 0, envioUsa = 0;
    productos.forEach(function (p) {
      var cant = parseInt(p.cantidad, 10) || 1;
      var linea = precioDe(p) * cant;
      valor += linea;
      if (v2 && pagaTaxUSA(p)) gravable += linea;
      envioUsa += (Number(p.envio_usa) || 0) * cant; /* v9: envio del vendedor en USA, por unidad */
      peso += (Number(p.peso) || 1) * cant;
      vol += (Number(p.vol) || 150) * cant;
    });
    var lbs = Math.ceil(peso * 2) / 2;
    var tipo = String(pedido.envio_tipo || '');
    var pais = String(pedido.pais || '');
    /* Argentina: FedEx cobra el mayor entre peso real y volumetrico (in3 / 139).
       vol=150 es el valor por defecto cuando no hay medidas: no pesa nada. */
    var lbsVol = pais.indexOf('AR') === 0 ? Math.ceil((vol / C.AR_DIM_FACTOR) * 2) / 2 : 0;
    var lbsAR = Math.max(lbs, lbsVol);

    var g = {
      v: v2 ? 2 : 1,
      productos: r2(valor),
      tax_usa: v2 ? r2(gravable * C.TAX_USA_PCT) : 0,
      tax_usa_pct: v2 ? C.TAX_USA_PCT : 0,
      envio_usa: r2(envioUsa),  /* v9 (19-oct-2026): lo que cobra la tienda por llevar el producto a nuestro almacen; se paga hoy y entra en la base del 15 % */
      envio: 0,
      seguro: 0,
      fee: 0,
      fee_pct: C.FEE_PCT,
      impuestos: 0,
      comisiones: 0,
      aranceles: 0,
      ar_modo: '',
      total: 0,
      reempaque: 'incluido',
      envio_metodo: tipo,
      envio_nota: '',
      impuestos_nota: '',
      caja: '',
      lbs: lbs,
      kg: 0,
      a_cotizar: false,
      pago_ahora: 0,
      pago_al_llegar: 0,
      moneda: 'USD',
      calculado: new Date().toISOString()
    };

    if (tipo.indexOf('A cotizar') === 0) {
      g.a_cotizar = true;
      g.seguro = valor > 0 && pais.indexOf('AR') !== 0 ? C.SEGURO_VE : 0;
      /* v2: el envio aun no se conoce; manejo sobre producto + tax */
      g.fee = v2 ? r2((valor + g.tax_usa + g.envio_usa) * C.FEE_PCT + C.FEE_FIJO)
                 : r2(valor * C.FEE_PCT + C.FEE_FIJO);
      g.envio_nota = 'El costo de envio se cotiza aparte';
    } else if (pais.indexOf('AR') === 0) {
      g.kg = Math.max(Math.ceil((peso / 2.20462) * 10) / 10, C.MINIMO_KG_AR);
      if (v2) {
        /* v7 (17-oct-2026): la tabla de cajas SOLO cuando todos los productos traen medidas
           (asi la caja es la real). Si alguno no trae medidas, o el pedido no entra en
           ninguna caja, el envio es un ESTIMADO de $25 por kilo (TARIFA_KG_AR), y se
           confirma al recibir el paquete. Decision de Jesus: "si no trae medidas, $25/kg y ya". */
        var sinMed = sinMedidasAR(productos);
        var selAR = sinMed ? null : cajaAR(lbs, volAR(productos), null, ladosAR(productos), piezasAR(productos));
        /* v8: propia caja (curva viva) cuando es mas barata que la caja de la tabla, o la caja se cotiza */
        var propia = sinMed ? null : propiaCajaAR(productos, lbs);
        if (propia && (!selAR || selAR.cotizar || propia.precio < selAR.precio)) {
          g.lbs = lbs;
          g.envio = propia.precio;
          g.caja = 'propia';
          g.caja_propia = true;
          g.caja_medidas = propia.medidas;
          g.caja_lb = propia.lb;
          g.caja_volumen = propia.por_volumen;
          g.caja_estimada = false;
          g.envio_nota = 'Viaja en su propia caja (' + propia.medidas + ', ' + propia.lb + ' lb' + (propia.por_volumen ? ' volumetricas' : '') + '): tarifa FedEx al dia.';
        } else if (selAR && selAR.cotizar) {
          /* v7: caja marcada "se cotiza" en la tabla (XL, XXL, Jumbo): el envio no se cobra
             por tabla, se cotiza a mano por WhatsApp para buscar el mejor precio */
          g.lbs = lbs;
          g.envio = 0;
          g.a_cotizar = true;
          g.caja = selAR.caja;
          g.caja_medidas = selAR.medidas;
          g.caja_cotizar = true;
          g.envio_nota = 'Tu pedido va en una caja grande (' + selAR.caja + '): el envio lo cotizamos por WhatsApp para conseguirte el mejor precio.';
        } else if (selAR) {
          g.lbs = lbs;
          g.envio = selAR.precio;
          g.caja = selAR.caja;
          g.caja_promo = selAR.promo;
          g.caja_hasta_lb = selAR.hasta_lb;
          g.caja_medidas = selAR.medidas;
          g.caja_estimada = false;
        } else {
          g.lbs = lbs;
          /* $25/kg YA INCLUYE el 26.4 % de impuestos del envio (decision de Jesus): la base
             es 25 / 1.264 y costosAR() le suma el 26.4 %, asi la linea "envio con impuestos" = kg x 25 */
          g.envio = r2(g.kg * C.TARIFA_KG_AR / (1 + C.IMP_AR_ENVIO_PCT));
          g.envio_estimado = true;
          g.envio_kg = g.kg;
          g.envio_nota = sinMed
            ? 'Envio estimado a $' + C.TARIFA_KG_AR + ' por kilo (impuestos incluidos): algun producto no trae medidas. Con las medidas reales el precio es exacto; lo confirmamos al recibir el paquete.'
            : 'Envio estimado a $' + C.TARIFA_KG_AR + ' por kilo (impuestos incluidos): el pedido no entra en nuestras cajas estandar. Lo confirmamos al recibir el paquete.';
        }
        var ar = costosAR(valor, g.envio, pedido.ar_modo || (pedido.desglose && pedido.desglose.ar_modo) || 'auto');
        g.ar_modo = ar.modo;
        g.aranceles = ar.aranceles;
        g.impuestos = ar.impuestos;
        g.impuestos_productos = ar.impuestos_productos;
        g.impuestos_envio = ar.impuestos_envio;
        g.comisiones = ar.comisiones; /* v5: 0 — las comisiones las paga JBOXLY */
        g.fee = r2((valor + g.tax_usa + g.envio_usa + g.envio + g.impuestos + g.comisiones) * C.FEE_PCT + C.FEE_FIJO);
        g.impuestos_nota = notaAR(ar);
      } else {
        g.envio = r2(g.kg * C.TARIFA_KG_AR);
        g.impuestos = r2(valor * 0.35);
        g.fee = r2(valor * C.FEE_PCT + C.FEE_FIJO);
        g.impuestos_nota = 'Estimado. Los productos tecnologicos se cotizan aparte.';
      }
    } else {
      if (tipo === 'Maritimo') {
        var caja = C.CAJAS[C.CAJAS.length - 1];
        for (var i = 0; i < C.CAJAS.length; i++) {
          if (vol <= C.CAJAS[i].vol) { caja = C.CAJAS[i]; break; }
        }
        g.caja = caja.nombre;
        g.envio = caja.precio;
      } else {
        g.envio = r2(lbs * C.TARIFA_LB_VE);
      }
      g.seguro = valor > 0 ? C.SEGURO_VE : 0;
      g.fee = v2 ? (valor > 0 ? r2((valor + g.tax_usa + g.envio_usa + g.envio) * C.FEE_PCT + C.FEE_FIJO) : 0)
                 : r2(valor * C.FEE_PCT + C.FEE_FIJO);
    }

    /* El total es la SUMA DE LAS LINEAS VISIBLES: si se sacara del
       calculo interno sin redondear, el cliente suma el desglose a
       mano y le da otro numero. */
    g.total = r2(g.productos + g.tax_usa + g.envio_usa + g.envio + g.seguro + g.fee + g.impuestos + g.comisiones);
    g.pago_ahora = r2(g.productos + g.tax_usa + g.envio_usa);
    g.pago_al_llegar = r2(g.envio + g.seguro + g.fee + g.impuestos + g.comisiones);
    return g;
  }

  /* Texto para el cliente: sin detalle de modos ni plataformas */
  function notaAR(ar) {
    if (!ar) return '';
    return 'Estimado. Incluye aranceles e IVA de Argentina sobre producto y flete. Los productos tecnologicos se cotizan aparte.';
  }

  function textoTotal(g) {
    return dinero(g.total) + (g.a_cotizar ? ' + envio' : '');
  }

  /* "8.25%" a partir del desglose (o de la tarifa actual) */
  function pctTax(g) {
    var p = (g && g.tax_usa_pct) || C.TAX_USA_PCT;
    return (Math.round(p * 10000) / 100) + '%';
  }

  /* Las lineas que se pintan, con las MISMAS etiquetas en las tres
     pantallas. Si una etiqueta cambia, cambia en todas a la vez. */
  function lineas(g) {
    var out = [{ etiqueta: 'Productos', valor: dinero(g.productos) }];
    if (g.tax_usa > 0) out.push({ etiqueta: 'Tax de compra en USA (' + pctTax(g) + ')', valor: dinero(g.tax_usa) });
    if (g.envio_usa > 0) out.push({ etiqueta: 'Envio del vendedor en Estados Unidos', valor: dinero(g.envio_usa) });
    if (g.seguro > 0) out.push({ etiqueta: 'Seguro obligatorio', valor: dinero(g.seguro) });
    out.push({ etiqueta: 'Manejo, logistica, consolidacion y reempaque', valor: dinero(g.fee) });
    if (g.impuestos > 0) out.push({ etiqueta: 'Impuestos de importacion (aprox)', valor: dinero(g.impuestos) });
    if (g.comisiones > 0) out.push({ etiqueta: 'Comisiones de pago y plataforma', valor: dinero(g.comisiones) });
    out.push({
      etiqueta: 'Envio' + (g.a_cotizar ? '' : (g.caja_propia ? ' (su propia caja, ' + (g.caja_lb || g.lbs) + ' lb)' : g.caja ? ' (caja ' + g.caja + ')'
        : (g.kg && !g.ar_modo) ? ' (' + g.kg.toFixed(1) + ' kg)'
        : g.lbs ? ' (' + g.lbs.toFixed(1) + ' lb' + (g.ar_modo ? ', FedEx' : '') + ')' : '')),
      valor: g.a_cotizar ? 'A cotizar' : dinero(g.envio)
    });
    return out;
  }

  /* Desglose de un pedido ya guardado. Usa el que quedo grabado; si
     el pedido es viejo y no lo tiene, lo recalcula al vuelo para que
     el historial tambien se vea completo. Los desgloses viejos no
     traen tax_usa: se completa en 0 para que nadie sume undefined. */
  function deOrden(d) {
    if (d && d.desglose && typeof d.desglose.total === 'number' && d.desglose.total > 0) {
      var g = d.desglose;
      if (typeof g.tax_usa !== 'number') g.tax_usa = 0;
      if (typeof g.envio_usa !== 'number') g.envio_usa = 0;
      if (typeof g.comisiones !== 'number') g.comisiones = 0;
      if (typeof g.aranceles !== 'number') g.aranceles = 0;
      return g;
    }
    return calcular(d || {}, (d && d.productos) || []);
  }

  w.JBXPrecios = {
    C: C, r2: r2, dinero: dinero, precioDe: precioDe,
    pagaTaxUSA: pagaTaxUSA, taxUSA: taxUSA, esV2: esV2, pctTax: pctTax, costosAR: costosAR, envioAR: envioAR, notaAR: notaAR,
    cajaAR: cajaAR, volAR: volAR, ladosAR: ladosAR, piezasAR: piezasAR, propiaCajaAR: propiaCajaAR, usarVivaAR: usarVivaAR, sinMedidasAR: sinMedidasAR, cabeEnCajaAR: cabeEnCajaAR, tarifaCajaAR: tarifaCajaAR, envioARFormula: envioARFormula, usarTarifasAR: usarTarifasAR, cargarTarifasAR: cargarTarifasAR, AR_TARIFAS_DEFAULT: AR_TARIFAS_DEFAULT,
    calcular: calcular, deOrden: deOrden, lineas: lineas, textoTotal: textoTotal
  };
})(window);